module.exports = __webpack_public_path__ + "static/media/fuel-icon.1b71fa14.svg";